export enum TxpDisableReason {
    None,
    FlightDisabled,
    TemporarilyAutoblocked,
    PermanentlyAutoblocked
}
